// Smoothly scrolls to an HMTL Element target
export function smoothScrollTo(elem:any, offsetTop:number = 0):void {
    var jump = (elem.getBoundingClientRect().top - offsetTop) * .2;
    document.body.scrollTop += jump;
    document.documentElement.scrollTop += jump;
    if (!elem.lastjump || elem.lastjump > Math.abs(jump)) {
        elem.lastjump = Math.abs(jump);
        setTimeout(function () { smoothScrollTo(elem, offsetTop); }, 20);
    } else {
        elem.lastjump = null;
    }
}